import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=6a2b68e6&scoped=true&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"
import style0 from "./Step1.vue?vue&type=style&index=0&id=6a2b68e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b68e6",
  null
  
)

/* custom blocks */
import block0 from "./Step1.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports